// extracted by mini-css-extract-plugin
module.exports = {"App":"QuickMode__App__28qNP","Input":"QuickMode__Input__10fsd","Row":"QuickMode__Row__1sV2k"};